import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import CustomerEditForm from '~/containers/customerEdit/customerEdit';
import CustomerArchive from '~/containers/customerArchive/customerArchive';

export class CustomerEditPage extends Component {
  state = {
    customer: null
  };

  onReceiveCustomer = ({ customer }) => {
    this.setState({
      customer
    });
  };

  render() {
    const customerId = this.props.match.params.customerId;
    const { customer } = this.state;

    const editButton = (
      <div className="flex">
        <CustomerArchive className="mr4" customer={customer} />
        <Link to={`/customers/${customerId}`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar
          back={`/customers/${customerId}`}
          backText="Customer"
          title={customer ? customer.name : '...'}
          button={editButton}
        />
        <CustomerEditForm onCompleted={this.onReceiveCustomer} id={customerId} />
      </Page>
    );
  }
}

export default withRouter(CustomerEditPage);



// WEBPACK FOOTER //
// ./src/pages/customerEdit/customerEdit.jsx